'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsBanner = exports.CmsBannerUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = require('react-redux');

var _decorator = require('helpers/decorator');

var _CmsModules = require('containers/CmsPage/CmsModules');

var _CmsAction = require('components/CmsPage/modules/CmsAction/CmsAction');

var _cmsDataToModuleArray = require('components/CmsPage/cmsDataToModuleArray');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, _ref) {
  var modules = _ref.modules;
  return {
    modules: (0, _cmsDataToModuleArray.cmsDataToModuleArray)(state, { modules: modules })
  };
};

var CmsBannerUnwrapped = exports.CmsBannerUnwrapped = function (_PureComponent) {
  (0, _inherits3.default)(CmsBannerUnwrapped, _PureComponent);

  function CmsBannerUnwrapped() {
    var _ref2;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, CmsBannerUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = CmsBannerUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(CmsBannerUnwrapped)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleCloseClick = function (event) {
      event.preventDefault();
      _this.props.onClose();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(CmsBannerUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          action = _props.action,
          modules = _props.modules,
          _props$position = _props.position,
          position = _props$position === undefined ? 'top' : _props$position,
          _props$theme = _props.theme,
          theme = _props$theme === undefined ? 'brand' : _props$theme;


      var banner = _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('banner banner--' + theme + ' banner--' + position + ' anim', {
            'anim--slideInDown': position === 'top',
            'anim--slideInUp': position === 'bottom'
          })
        },
        _react2.default.createElement(
          'span',
          { className: 'banner__close banner__close--' + theme, onClick: this.handleCloseClick },
          'x'
        ),
        _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
      );

      if (action) {
        return _react2.default.createElement(
          _CmsAction.CmsAction,
          { actionType: action.actionType, actionValue: action.actionValue },
          banner
        );
      }

      return banner;
    }
  }]);
  return CmsBannerUnwrapped;
}(_react.PureComponent);

CmsBannerUnwrapped.propTypes = {
  action: _propTypes2.default.shape({
    actionType: _propTypes2.default.string.isRequired,
    actionValue: _propTypes2.default.string
  }),
  modules: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    cmsModuleId: _propTypes2.default.string.isRequired
  }).isRequired).isRequired,
  onClose: _propTypes2.default.func.isRequired,
  position: _propTypes2.default.oneOf(['top', 'bottom']),
  theme: _propTypes2.default.oneOf(['dark', 'white', 'brand'])
};

var CmsBanner = exports.CmsBanner = (0, _decorator.decorateWith)((0, _reactRedux.connect)(mapStateToProps))(CmsBannerUnwrapped);